/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { RouteChildrenProps } from 'react-router-dom'
import classNames from 'classnames/bind'
import { ROUTES } from 'constants/routes'
import { Text } from 'hocs/localization'
import Icon from 'elements/Icon'
import { ITEM_TYPES } from './constants'
import * as styles from './UserControls.scss'

const cx = classNames.bind(styles)

interface IProps extends RouteChildrenProps {
  greeting: string,
  onLogout: () => void,
  texts: any,
  t: Text,
  isUserAbleToOpenProfile: boolean,
}

interface IState {
  isDropdownVisible: boolean,
}

class UserControls extends React.Component<IProps, IState> {
  public readonly state = {
    isDropdownVisible: false,
  }

  private dropdownButtonRef = null

  private dropdownRef = null

  public componentWillUnmount () {
    window.removeEventListener('mousedown', this.onCheckClickOutsideDropdown)
  }

  private onToggleDropdown = () => {
    const isDropdownVisible = !this.state.isDropdownVisible
    if (isDropdownVisible) {
      this.onOpenDropdown()
    } else {
      this.onCloseDropdown()
    }
  }

  private onOpenDropdown = () => {
    this.setState({
      isDropdownVisible: true,
    })
    window.addEventListener('mousedown', this.onCheckClickOutsideDropdown)
  }

  private onCloseDropdown = () => {
    this.setState({
      isDropdownVisible: false,
    })
    window.removeEventListener('mousedown', this.onCheckClickOutsideDropdown)
  }

  private onCheckClickOutsideDropdown = event => {
    let target = event.target
    let isClickedOutside = true

    while (target !== document && isClickedOutside) {
      if (target === this.dropdownRef || target === this.dropdownButtonRef) {
        isClickedOutside = false
      }
      target = target.parentNode
    }
    if (isClickedOutside) {
      this.onCloseDropdown()
    }
  }

  private onClickDropdownItem = type => {
    if (type === ITEM_TYPES.profile) {
      this.props.history.push(ROUTES.profile.view)
      this.onCloseDropdown()
      return
    }
    if (type === ITEM_TYPES.settings) {
      this.props.history.push(ROUTES.profile.settings)
      this.onCloseDropdown()
      return
    }
    if (type === ITEM_TYPES.logout) {
      this.props.onLogout()
      this.onCloseDropdown()
      return
    }
  }

  public render () {
    const {
      greeting,
      t,
      isUserAbleToOpenProfile,
    } = this.props

    return(
      <div className={styles.root}>
        <ul>
          <li className={styles.item}>
            <button
              onClick={this.onToggleDropdown}
              className={styles.dropdownButton}
              ref={r => { this.dropdownButtonRef = r }}
            >
              <span>{greeting}</span>
              <Icon name='chevronDown'/>
            </button>
            <ul
              ref={r => { this.dropdownRef = r }}
              className={cx(
                'dropdown',
                {
                  visible: this.state.isDropdownVisible,
                },
              )}
            >
              {isUserAbleToOpenProfile && [
                <li key='view'>
                  <button onClick={() => this.onClickDropdownItem(ITEM_TYPES.profile)}>{t('goToProfile')}</button>
                </li>,
                <li key='settings'>
                  <button onClick={() => this.onClickDropdownItem(ITEM_TYPES.settings)}>{t('goToSettings')}</button>
                </li>,
              ]}
              <li><button onClick={() => this.onClickDropdownItem(ITEM_TYPES.logout)}>{t('logout')}</button></li>
            </ul>
          </li>
        </ul>
      </div>
    )
  }
}

export default UserControls
